import { render, staticRenderFns } from "./CUploaderLanguagesModal.vue?vue&type=template&id=15ab1af8&scoped=true&"
import script from "./CUploaderLanguagesModal.vue?vue&type=script&lang=js&"
export * from "./CUploaderLanguagesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ab1af8",
  null
  
)

export default component.exports